const data = [
  {
    id: "sec_1",
    header_1: "01",
    header_2: ["What", "we do"],
    description:
      "With end-to-end capabilities, we bring together textile form factor design, wearable sensor electronics inclusion, and manufacturing all under our roof. Backed by our powerhouse R&D department, we help guide you throughout the transformation journey and together create a future-ready solution - today. we are proud to keep adding more and more possibilities to our portfolio.Learn more about the solutions that are already available."
  },
  {
    id: "sec_2",
    header_1: "02",
    header_2: ["What", "we say"],
    description:
      "With end-to-end capabilities, we bring together textile form factor design, wearable sensor electronics inclusion, and manufacturing all under our roof. Backed by our powerhouse R&D department, we help guide you throughout the transformation journey and together create a future-ready solution - today. we are proud to keep adding more and more possibilities to our portfolio.Learn more about the solutions that are already available."
  },
  {
    id: "sec_3",
    header_1: "03",
    header_2: ["why", "we say"],
    description:
      "With end-to-end capabilities, we bring together textile form factor design, wearable sensor electronics inclusion, and manufacturing all under our roof. Backed by our powerhouse R&D department, we help guide you throughout the transformation journey and together create a future-ready solution - today. we are proud to keep adding more and more possibilities to our portfolio.Learn more about the solutions that are already available."
  }
];

export default data;
